<template>
  <div id="app">
    <external-link-popup></external-link-popup>
    <app-header></app-header>
    <app-videoContent :overlayContent="overlayContent" ref="videoContent"></app-videoContent>
    <app-menuContent :overlayContent="overlayContent" ref="menuContent" v-if="initialPrefs.menuVisible"></app-menuContent>
    <slide-player :overlayContent="overlayContent" ref="slidePlayerContent" v-if="!!initialPrefs.slideVisible"></slide-player>
    <app-footer v-if="initialPrefs.footerVisible"></app-footer>
  </div>
</template>

<script>
import menuContent from './components/menu-content'
import videoContent from './components/video-content'
import header from './components/header'
import footer from './components/footer'
import slidePlayer from './components/slide-player'
import externalLinkPopup from './components/external-link-popup.vue'

export default {
  name: 'App',
  components: {
    'app-menuContent':menuContent,
    'app-videoContent':videoContent,
    'app-header':header,
    'app-footer':footer,
    'slide-player':slidePlayer,
    'external-link-popup':externalLinkPopup,
  },
  methods: {
    runMethods(time){
      if(this.$refs.menuContent!=null)
        this.$refs.menuContent.runMethods(time);
      if(this.$refs.slidePlayerContent!=null)
        this.$refs.slidePlayerContent.process(time);
    },
    seektoTime(time,play){
      this.$refs.videoContent.seektoTime(time,play);
    },
    toggleSlide(){
      if(this.$refs.slidePlayerContent!=null){
          this.$refs.slidePlayerContent.toggleVisible()
      }
    },
    resetSlidePlayerPostion(){
      this.$refs.slidePlayerContent.resetXtranslate();
    }
  },
  data() {
    return {
      overlayContent : require("./assets/overlayContent.json")
    };
  },
  created(){
    window.document.title = this.initialPrefs.projectName;
    if(!Array.isArray(parent.dataLayer)){
      window.dataLayer=[]
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
      display: flex;
    flex-direction: column;
}
</style>
